/**
 * @generated SignedSource<<2b1ceb7e2ee5a6ac6fc6e98060e9f268>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AnonymizeAccountAsOwnerInput = {
  clientMutationId?: string | null;
};
export type confirmDeleteAccountModal_AnonymizeAccountAsManagerMutation$variables = {
  input: AnonymizeAccountAsOwnerInput;
};
export type confirmDeleteAccountModal_AnonymizeAccountAsManagerMutation$data = {
  readonly AccountMemberManagement: {
    readonly anonymizeAccountAsOwner: {
      readonly deletedIds: ReadonlyArray<string>;
    } | null;
  };
};
export type confirmDeleteAccountModal_AnonymizeAccountAsManagerMutation = {
  response: confirmDeleteAccountModal_AnonymizeAccountAsManagerMutation$data;
  variables: confirmDeleteAccountModal_AnonymizeAccountAsManagerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AccountMemberManagementMutations",
    "kind": "LinkedField",
    "name": "AccountMemberManagement",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "AnonymizeAccountAsOwnerPayload",
        "kind": "LinkedField",
        "name": "anonymizeAccountAsOwner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deletedIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "confirmDeleteAccountModal_AnonymizeAccountAsManagerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "confirmDeleteAccountModal_AnonymizeAccountAsManagerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bcf6ddb3c1a540849a4f2fcba3b26fe7",
    "id": null,
    "metadata": {},
    "name": "confirmDeleteAccountModal_AnonymizeAccountAsManagerMutation",
    "operationKind": "mutation",
    "text": "mutation confirmDeleteAccountModal_AnonymizeAccountAsManagerMutation(\n  $input: AnonymizeAccountAsOwnerInput!\n) {\n  AccountMemberManagement {\n    anonymizeAccountAsOwner(input: $input) {\n      deletedIds\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "13642bbc317e6110f75c572559b89f30";

export default node;
